import { render } from "./AdminEditTicket.vue?vue&type=template&id=5c72fcb2&scoped=true"
import script from "./AdminEditTicket.vue?vue&type=script&lang=js"
export * from "./AdminEditTicket.vue?vue&type=script&lang=js"

import "./AdminEditTicket.vue?vue&type=style&index=0&id=5c72fcb2&scoped=true&lang=css"

import exportComponent from "D:\\CTS_SURAJ\\mahatakrar\\Admin_eticket_ui\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5c72fcb2"]])

export default __exports__